
<div class="container" style="border:1px solid #bebaba">
  <br />
  <div class="row indentContent">
    <div class="col-md-12">
      <h3 style="font-weight:bold">Claim Filing</h3>
      <p>To receive any of these benefits, you must submit the Claim Form below by October 30, 2026.</p>

      To Submit an online Claim Form, please click <a [routerLink]="['/login']">here</a><br /><br />

      To download a blank copy of the Claim Form, please click <a href="../../../assets/docs/AgriStats/Exhibit 4 - Revised Claim Form-Final.pdf" target="_blank">HERE</a><br /><br />
      Return the paper Claim Form via Mail to:<br />
      Turkey Antitrust Litigation<br />
      c/o A.B. Data, Ltd.<br />
      P.O. Box 173015<br />
      Milwaukee, WI  53217<br />


  <br />
      </div>
</div>
  </div>
